import { render, staticRenderFns } from "./Autos.vue?vue&type=template&id=50636f67&scoped=true&"
import script from "./Autos.vue?vue&type=script&lang=js&"
export * from "./Autos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50636f67",
  null
  
)

export default component.exports